import { React, useState, useEffect } from 'react'

import CardDashboard from "../../components/CardDashboard";
import CardTotais from "../../components/CardDashboard/CardTotais";
import { width, generateId } from "../../helpers";
import { sendData, getData } from "../../services/auth";
import { Aguarde, getCookie } from '../../helpers/general'
import { uriList } from "../../helpers/config";
import { useSelector } from "react-redux";
import UploadDocumentos from '../integracao/Documentos/UploadDocumentos'
import InclusaoIntegracoes from '../integracao/Integracoes/InclusaoIntegracoes'
import Documentos from '../integracao/Documentos'
import Integracoes from '../integracao/Integracoes'

import { format } from 'date-fns'

const Index = (props) => {
    const [documentos, setDocumentos] = useState(null);
    const [integracoes, setIntegracoes] = useState(null);
    const [docVencidos, setDocVencidos] = useState(null);
    const [docProxVecto, setDocProxVecto] = useState(null);

    const [intVencidas, setIntVencidas] = useState(null);
    const [intProxVecto, setIntProxVecto] = useState(null);
    const [loading, setLoading] = useState(false)
    const [editing, setEditing] = useState(false)
    const [editingIntegracao, setEditIntegracao] = useState(false)
    const [pesqDocumentos, setPesqDocumentos] = useState(null)
    const [pesqIntegracoes, setPesqIntegracoes] = useState(null)

    const _login = useSelector((state) => state.login);

    useEffect(() => {
        _getData();
    }, [])

    async function _getData() {
        let loadeds = 0
        setLoading(true)

        //-- Documentos vencidos-
        sendData({ uri: uriList("listarDocumentos"), })
            .then((_res) => {
                console.log("Dasboard.index(listarDocumentos): ", _res);
                const res = _res.data || _res
                if (res) {
                    setDocVencidos(res.filter((doc) => doc.vencido == 'SIM' || doc.VENCIDO == 'SIM'))
                    const _proxVencto = res.filter((doc) => doc.proximo_vencer == 'SIM' || doc.PROXIMO_VENCER == 'SIM')
                    setDocProxVecto(_proxVencto)
                    let _documentos = [{ TOTAL: 0, VALIDOS: 0, VENCIDOS: 0, PROX_VENCIMENTO: 0 },
                    { TOTAL: 0, VALIDOS: 0, VENCIDOS: 0, PROX_VENCIMENTO: 0 }]
                    res.map((doc) => {
                        let ind = 0
                        if (doc.EMPRESASN != 'SIM')
                            ind = 1
                        _documentos[ind].TOTAL += 1
                        if (doc.vencido == 'SIM' || doc.VENCIDO == 'SIM') _documentos[ind].VENCIDOS += 1
                        else if (doc.proximo_vencer == 'SIM' || doc.PROXIMO_VENCER == 'SIM') _documentos[ind].PROX_VENCIMENTO += 1
                        else _documentos[ind].VALIDOS += 1
                    })
                    setDocumentos(_documentos)

                }
                loadeds += 1
                if (loadeds == 2) setLoading(false)
            })
            .catch(error => {
                loadeds += 1
                if (loadeds == 2) setLoading(false)
                console.log(error);
            })

        sendData({ uri: uriList("listIntegracoes"), })
            .then((_res) => {
                const res = _res.data || _res
                console.log("Dasboard.index(listIntegracoes): ", res);
                if (res) {
                    setIntVencidas(res.filter((int) => int.vencido == 'SIM' || int.VENCIDO == 'SIM'))
                    setIntProxVecto(res.filter((int) => int.proximo_vencer == 'SIM' || int.PROXIMO_VENCER == 'SIM'))

                    let _integracoes = [{ TOTAL: 0, VALIDOS: 0, VENCIDOS: 0, PROX_VENCIMENTO: 0 },
                    { TOTAL: 0, VALIDOS: 0, VENCIDOS: 0, PROX_VENCIMENTO: 0 }]
                    res.map((int) => {
                        let ind = 0
                        if (ind.EMPRESASN != 'SIM')
                            ind = 1
                        _integracoes[ind].TOTAL += 1
                        if (int.vencido == 'SIM' || int.VENCIDO == 'SIM') _integracoes[ind].VENCIDOS += 1
                        else if (int.proximo_vencer == 'SIM' || int.PROXIMO_VENCER == 'SIM') _integracoes[ind].PROX_VENCIMENTO += 1
                        else _integracoes[ind].VALIDOS += 1
                    })
                    setIntegracoes(_integracoes)
                }
                loadeds += 1
                if (loadeds == 2) setLoading(false)
            })
            .catch(error => {
                loadeds += 1
                if (loadeds == 2) setLoading(false)
                console.log(error);
            })
    }

    function editDocument(doc) {
        console.log("Dashboard.index(editDocument): ", doc);
        setEditing(doc)
    }

    function editIntegracao(int) {
        console.log("Dashboard.index(editIntegracao): ", int);
        setEditIntegracao(int)
    }

    function handlePesqDocumentos(posicao, empresa) {
        setPesqDocumentos({ posicao, empresa })
    }

    function handlePesqIntegracoes(posicao) {
        console.log("Dashboard.index(handlePesqIntegracoes): ", posicao);
        setPesqIntegracoes({ posicao })
    }


    return (
        <div style={{ height: "80vh", overflowY: "auto" }}>
            {
                pesqDocumentos &&
                <Documentos posicao={pesqDocumentos.posicao} onCloseEv={() => setPesqDocumentos(null)} empresa={pesqDocumentos.empresa} />
            }
            {
                pesqIntegracoes &&
                <Integracoes posicao={pesqIntegracoes.posicao} onCloseEv={() => setPesqIntegracoes(null)} />
            }

            {!pesqIntegracoes && !pesqDocumentos &&
                <div className="row col-12 d-flex justify-content-center align-items-center mb-2">
                    {editing &&
                        <UploadDocumentos
                            onCloseEv={() => setEditing(false)}
                            pessoaid={editing.PESSOAID}
                            empresa={editing.EMPRESA}
                            data={editing} />
                    }
                    {editingIntegracao &&
                        <InclusaoIntegracoes
                            onCloseEv={() => setEditIntegracao(false)}
                            empresa={_login.empresaid}
                            data={editingIntegracao} />
                    }

                    <div
                        // className={`row ml-1 ${width() == "mobile" ? "col-12" : "col-4"} d-flex justify-content-center align-items-center `}
                        className={`row ml-1 d-flex justify-content-center align-items-center ${width() == "mobile" ? "mt-2 col-12" : "col-4"}`}
                    >
                        <div style={{
                            boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px",
                            borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #28a745 , #7ad781)"
                        }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-building" /></div>
                                <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", color: "#fff" }}>Resumo - Empresa</span></div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Total:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('', true)}>
                                        {(documentos && documentos[0]?.TOTAL) || 0}
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Válidos:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('ATIVO', true)}>
                                        {(documentos && documentos[0]?.VALIDOS) || 0}
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Vencidos:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('VENCIDO', true)}>
                                        {(documentos && documentos[0]?.VENCIDOS) || 0}
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Prox. Venc:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('VENCENDO', true)}>
                                        {(documentos && documentos[0]?.PROX_VENCIMENTO) || 0}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{
                            marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px",
                            borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px",
                            backgroundImage: "linear-gradient(to bottom, #28a745 , #7ad781)"
                        }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-building" /></div>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: 'column', width: "100%" }}>
                                    {/* <div style={{textAlign:"center", width:"100%"}}><span style={{fontSize:"20px", color:"#fff"}}>Docs da Empresa</span></div> */}
                                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", fontWeight: "bold", color: "#fff" }} >Vencidos</span></div>
                                </div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px", flexDirection: "column" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", fontWeight: "bold", color: '#fff' }}>
                                    <div style={{ textAlign: "left", width: "25%" }} ><span>{width() == "mobile" ? "Vecto" : "Vencimento"}</span></div>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>Tipo</span></div>
                                    <div style={{ textAlign: "left", width: "50%" }}><span>Nome</span></div>
                                </div>
                                <div style={{ display: "flex", width: "100%", fontWeight: "bold", color: '#fff', flexDirection: "column", minHeight: "200px", maxHeight: "200px", overflowX: "auto" }}>
                                    {docVencidos?.filter(item => item.EMPRESASN == 'SIM')?.map((item, key) => {
                                        return (
                                            <div
                                                onClick={e => editDocument(item)}
                                                style={{
                                                    display: "flex", width: "100%",
                                                    justifyContent: "space-between", fontWeight: "normal", paddingTop: "5px", cursor: "pointer"
                                                }}
                                                key={key}
                                            >
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{format(new Date(item.VALIDADE), 'dd/MM/yyyy')}</span></div>
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{item.DESCRICAO}</span></div>
                                                <div style={{ textAlign: "left", width: "50%" }}><span>{item.PESSOA}</span></div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px", borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #28a745 , #7ad781)" }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-building" /></div>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: 'column', width: "100%" }}>
                                    {/* <div style={{textAlign:"center", width:"100%"}}><span style={{fontSize:"20px", color:"#fff"}}>Docs da Empresa</span></div> */}
                                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", fontWeight: "bold", color: "#fff" }}>Prox. Vencimento</span></div>
                                </div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px", flexDirection: "column" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", fontWeight: "bold", color: '#fff' }}>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>{width() == "mobile" ? "Vecto" : "Vencimento"}</span></div>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>Tipo</span></div>
                                    <div style={{ textAlign: "left", width: "50%" }}><span>Nome</span></div>
                                </div>
                                <div style={{ display: "flex", width: "100%", fontWeight: "bold", color: '#fff', flexDirection: "column", maxHeight: "200px", overflowX: "auto" }}>
                                    {docProxVecto?.filter(item => item.EMPRESASN == 'SIM')?.map((item, key) => {
                                        return (
                                            <div
                                                onClick={e => editDocument(item)}
                                                style={{ display: "flex", width: "100%", justifyContent: "space-between", fontWeight: "normal", paddingTop: "5px", cursor: "pointer" }}
                                                key={key}
                                            >
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{format(new Date(item.VALIDADE), 'dd/MM/yyyy')}</span></div>
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{item.DESCRICAO.substring(0, 10)}</span></div>
                                                <div style={{ textAlign: "left", width: "50%" }}><span>{item.PESSOA}</span></div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`row ml-1 d-flex justify-content-center align-items-center ${width() == "mobile" ? "mt-2 col-12" : "col-4"}`}
                    // className={`row ml-1 ${width() == "mobile" ? "col-12" : "col-4"} d-flex justify-content-center align-items-center `}
                    >
                        <div style={{ boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px", borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #17a2b8 , #47bfd6)" }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-users" /></div>
                                <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", color: "#fff" }}>Resumo - Técnicos</span></div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Total:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('')}>
                                        {(documentos && documentos[1].TOTAL) || 0}
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Válidos:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('ATIVO')}>
                                        {(documentos && documentos[1].VALIDOS) || 0}
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Vencidos:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('VENCIDO')}>
                                        {(documentos && documentos[1].VENCIDOS) || 0}
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Prox. Venc:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqDocumentos('VENCENDO')}>
                                        {(documentos && documentos[1].PROX_VENCIMENTO) || 0}</div>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px", borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #17a2b8 , #47bfd6)" }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-users" /></div>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: 'column', width: "100%" }}>
                                    {/* <div style={{textAlign:"center", width:"100%"}}><span style={{fontSize:"20px", color:"#fff"}}>Docs da Empresa</span></div> */}
                                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", fontWeight: "bold", color: "#fff" }} >Vencidos</span></div>
                                </div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px", flexDirection: "column" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", fontWeight: "bold", color: '#fff' }}>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>{width() == "mobile" ? "Vecto" : "Vencimento"}</span></div>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>Tipo</span></div>
                                    <div style={{ textAlign: "left", width: "50%" }}><span>Nome</span></div>
                                </div>
                                <div style={{ display: "flex", width: "100%", fontWeight: "bold", color: '#fff', flexDirection: "column", minHeight: "200px", maxHeight: "200px", overflowX: "auto" }}>
                                    {docVencidos?.filter(item => item.EMPRESASN == 'NAO')?.map((item, key) => {
                                        return (
                                            <div
                                                onClick={e => editDocument(item)}
                                                style={{ display: "flex", width: "100%", justifyContent: "space-between", fontWeight: "normal", paddingTop: "5px", cursor: "pointer" }}
                                                key={key}
                                            >
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{format(new Date(item.VALIDADE), 'dd/MM/yyyy')}</span></div>
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{item.DESCRICAO}</span></div>
                                                <div style={{ textAlign: "left", width: "50%" }}><span>{item.PESSOA}</span></div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px", borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #17a2b8 , #47bfd6)" }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-users" /></div>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: 'column', width: "100%" }}>
                                    {/* <div style={{textAlign:"center", width:"100%"}}><span style={{fontSize:"20px", color:"#fff"}}>Docs da Empresa</span></div> */}
                                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", fontWeight: "bold", color: "#fff" }}>Prox. Vencimento</span></div>
                                </div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px", flexDirection: "column" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", fontWeight: "bold", color: '#fff' }}>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>{width() == "mobile" ? "Vecto" : "Vencimento"}</span></div>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>Tipo</span></div>
                                    <div style={{ textAlign: "left", width: "50%" }}><span>Nome</span></div>
                                </div>
                                <div style={{ display: "flex", width: "100%", fontWeight: "bold", color: '#fff', flexDirection: "column", minHeight: "200px", maxHeight: "200px", overflowX: "auto" }}>
                                    {docProxVecto?.filter(item => item.EMPRESASN == 'NAO')?.map((item, key) => {
                                        return (
                                            <div
                                                onClick={e => editDocument(item)}
                                                style={{ display: "flex", width: "100%", justifyContent: "space-between", fontWeight: "normal", paddingTop: "5px", cursor: "pointer" }}
                                                key={key}
                                            >
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{format(new Date(item.VALIDADE), 'dd/MM/yyyy')}</span></div>
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{item.DESCRICAO?.substring(0, 10)}</span></div>
                                                <div style={{ textAlign: "left", width: "50%" }}><span>{item.PESSOA}</span></div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`row ml-1 d-flex justify-content-center align-items-center ${width() == "mobile" ? "mt-2 col-12" : "col-4"}`}
                    // className={`row ml-1 ${width() == "mobile" ? "col-12" : "col-4"} d-flex justify-content-center align-items-center `}
                    >
                        <div style={{ boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px", borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #007bff , #4793ff)" }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-indent" /></div>
                                <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", color: "#fff" }}>Resumo - Integrações</span></div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Total:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqIntegracoes('')}>
                                        {(integracoes && integracoes[1].TOTAL) || 0}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Válidos:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqIntegracoes('ATIVO')}>
                                        {(integracoes && integracoes[1].VALIDOS) || 0}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Vencidos:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqIntegracoes('VENCIDO')}>
                                        {(integracoes && integracoes[1].VENCIDOS) || 0}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: "#fff" }}>Prox. Venc:</div>
                                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", cursor: "pointer" }}
                                        onClick={() => handlePesqIntegracoes('VENCENDO')}>
                                        {(integracoes && integracoes[1].PROX_VENCIMENTO) || 0}</div>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px", borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #007bff , #4793ff)" }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-indent" /></div>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: 'column', width: "100%" }}>
                                    {/* <div style={{textAlign:"center", width:"100%"}}><span style={{fontSize:"20px", color:"#fff"}}>Docs da Empresa</span></div> */}
                                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", fontWeight: "bold", color: "#fff" }} >Vencidos</span></div>
                                </div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px", flexDirection: "column" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", fontWeight: "bold", color: '#fff' }}>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>{width() == "mobile" ? "Vecto" : "Vencimento"}</span></div>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>Cliente</span></div>
                                    <div style={{ textAlign: "left", width: "50%" }}><span>Nome</span></div>
                                </div>
                                <div style={{ display: "flex", width: "100%", fontWeight: "bold", color: '#fff', flexDirection: "column", minHeight: "200px", maxHeight: "200px", overflowX: "auto" }}>
                                    {intVencidas?.map((item, key) => {
                                        return (
                                            <div
                                                onClick={e => editIntegracao(item)}
                                                style={{ display: "flex", width: "100%", justifyContent: "space-between", fontWeight: "normal", paddingTop: "5px", cursor: "pointer" }}
                                                key={key}
                                            >
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{format(new Date(item.VALIDADE), 'dd/MM/yyyy')}</span></div>
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{item.CLIENTE?.substring(0, 20)}</span></div>
                                                <div style={{ textAlign: "left", width: "50%" }}><span>{item.PESSOA}</span></div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 6px -1px, rgba(0, 0, 0, 0.5) 0px 2px 4px -1px", borderRadius: "5px", border: "1px solid #dee2e6;", padding: "20px", backgroundImage: "linear-gradient(to bottom, #007bff , #4793ff)" }}>
                            <div style={{ display: "flex" }}>
                                <div><i style={{ fontSize: "24px", color: "#fff" }} className="fa fa-indent" /></div>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: 'column', width: "100%" }}>
                                    {/* <div style={{textAlign:"center", width:"100%"}}><span style={{fontSize:"20px", color:"#fff"}}>Docs da Empresa</span></div> */}
                                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", fontWeight: "bold", color: "#fff" }}>Prox. Vencimento</span></div>
                                </div>
                            </div>
                            <div style={{ borderTop: "1px dashed #fff", display: "flex", justifyContent: "space-around", paddingTop: "15px", flexDirection: "column" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", fontWeight: "bold", color: '#fff' }}>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>{width() == "mobile" ? "Vecto" : "Vencimento"}</span></div>
                                    <div style={{ textAlign: "left", width: "25%" }}><span>Cliente</span></div>
                                    <div style={{ textAlign: "left", width: "50%" }}><span>Nome</span></div>
                                </div>
                                <div style={{ display: "flex", width: "100%", fontWeight: "bold", color: '#fff', flexDirection: "column", maxHeight: "200px", overflowX: "auto" }}>
                                    {intProxVecto?.map((item, key) => {
                                        return (
                                            <div
                                                onClick={e => editIntegracao(item)}
                                                style={{ display: "flex", width: "100%", justifyContent: "space-between", fontWeight: "normal", paddingTop: "5px", cursor: "pointer" }}
                                                key={key}
                                            >
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{format(new Date(item.VALIDADE), 'dd/MM/yyyy')}</span></div>
                                                <div style={{ textAlign: "left", width: "25%" }}><span>{item.CLIENTE?.substring(0, 10)}</span></div>
                                                <div style={{ textAlign: "left", width: "50%" }}><span>{item.PESSOA}</span></div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {loading && <Aguarde legenda={"Aguarde, carregando dados..."} />}
        </div>
    );
}

export default Index;